import Logo from "./Logo";

const LINKS = [
    { label: "Servizi", id: "servizi" },
    { label: "Perché noi", id: "perche-noi" },
    { label: "Offerte", id: "catalogo" },
    { label: "Chi siamo", id: "chi-siamo" },
    { label: "Contatti", id: "contatti" },
];

export default function Footer() {
    return (
        <footer className="border-t border-line bg-background">
            <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14 grid md:grid-cols-3 gap-10">
                <div>
                    <Logo />
                    <p className="mt-5 max-w-xs text-sm leading-relaxed text-muted-foreground">
                        Ricambi ed elettrodomestici delle
                        migliori marche, da trent'anni a Scanzano Jonico.
                    </p>
                </div>

                <nav className="flex flex-col gap-3">
                    <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground mb-1">
                        Naviga
                    </p>
                    {LINKS.map((l) => (
                        <a
                            key={l.id}
                            href={`#${l.id}`}
                            data-testid={`footer-link-${l.id}`}
                            className="text-sm text-foreground/80 hover:text-primary transition-colors w-fit"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>

                <div className="flex flex-col gap-3 text-sm text-muted-foreground">
                    <p className="font-mono text-[10px] tracking-[0.3em] uppercase mb-1">
                        CG Service SRL
                    </p>
                    <p>Via degli Artigiani snc, 75020 Scanzano Jonico (MT)</p>
                    <a href="tel:+390835981465" data-testid="footer-phone" className="hover:text-primary transition-colors w-fit">
                        0835 981465
                    </a>
                    <a href="mailto:info@cgservicesrl.it" data-testid="footer-email" className="hover:text-primary transition-colors w-fit">
                        info@cgservicesrl.it
                    </a>
                    <p>P.IVA 01312450776</p>
                </div>
            </div>

            <div className="border-t border-line">
                <div className="mx-auto max-w-7xl px-5 sm:px-8 py-6 flex flex-wrap justify-between gap-3">
                    <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
                        © {new Date().getFullYear()} CG Service SRL · Tutti i diritti riservati
                    </p>
                    <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-muted-foreground">
                        Ordina su WhatsApp · Paga in negozio ·{" "}
                        <a href="/admin" data-testid="footer-admin" className="underline underline-offset-2 hover:text-foreground transition-colors">
                            Area Riservata
                        </a>
                    </p>
                </div>
            </div>
        </footer>
    );
}